
import axiosClient from "../../../api/axiosClient";

const BASE_URL = "/api/trading/enquiries";

const tradingEnquiryService = {
  getEnquiries(params = {}) {
    return axiosClient.get(BASE_URL, { params });
  },

  getEnquiry(enquiryId) {
    return axiosClient.get(`${BASE_URL}/${enquiryId}`);
  },

  createEnquiry(payload) {
    return axiosClient.post(BASE_URL, payload);
  },

  getEnquiryItems(enquiryId) {
    return axiosClient.get(`${BASE_URL}/${enquiryId}/items`);
  },

  addEnquiryItem(enquiryId, payload) {
    return axiosClient.post(
      `${BASE_URL}/${enquiryId}/items`,
      payload
    );
  },

  
  searchCustomers(search) {
    return axiosClient.get(
      "/api/ppe/masters/business-partner/customers/lookup",
      { params: { search } }
    );
  },

  searchRawMaterials(q) {
    return axiosClient.get(
      "/api/ppe/masters/raw-materials/search",
      { params: { q } }
    );
  },

  
  updateEnquiry(enquiryId, payload) {
    return axiosClient.put(`${BASE_URL}/${enquiryId}`, payload);
  },

  deleteEnquiry(enquiryId) {
    return axiosClient.delete(`${BASE_URL}/${enquiryId}`);
  },

  updateEnquiryItem(enquiryId, itemId, payload) {
    return axiosClient.put(
      `${BASE_URL}/${enquiryId}/items/${itemId}`,
      payload
    );
  },

  deleteEnquiryItem(enquiryId, itemId) {
    return axiosClient.delete(
      `${BASE_URL}/${enquiryId}/items/${itemId}`
    );
  },

  getAllowedTransitions(enquiryId) {
    return axiosClient.get(`${BASE_URL}/${enquiryId}/transitions`);
  },

  changeEnquiryStatus(enquiryId, newStatus) {
    return axiosClient.post(
      `${BASE_URL}/${enquiryId}/change-status`,
      { new_status: newStatus }
    );
  },

};

export default tradingEnquiryService;
